(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function(e){
  // Open when the magnifier is tapped (in the header search block)
  const openBtn = e.target.closest('.header__search .search__icon-search');
  if (openBtn && !document.body.classList.contains('is-search-open')) {
    // prevent immediate form submit when closed; we just want to open
    e.preventDefault();
    document.body.classList.add('is-search-open');
    const input = document.querySelector('.header__search .search__input');
    if (input) { setTimeout(() => input.focus(), 0); }
  }

  // Close button
  const closeBtn = e.target.closest('.header__search-close');
  if (closeBtn) {
    e.preventDefault();
    document.body.classList.remove('is-search-open');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-search-clean"]) return;
  try {
    
  // Search-template hardening: remove any leftover locks and prevent “overlay steals scroll”.
  (function() {
    function unlock() {
      document.body.classList.remove('search-open');
      // Kill any stray theme overlays if present
      document.querySelectorAll('.fixed-overlay').forEach(function(el){
        el.style.opacity = '0'; el.style.visibility = 'hidden'; el.style.pointerEvents = 'none';
      });
    }
    document.addEventListener('DOMContentLoaded', unlock);
    window.addEventListener('pageshow', unlock); // back/forward cache safety
  })();

  } catch(e) { console.error(e); }
})();
})();
